<template>
  <div class="signup-view">
    <PasswordReset />
  </div>
</template>

<script>
import PasswordReset from "@/components/templates/PasswordReset";

export default {
  components: { PasswordReset },
};
</script>